// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"476543c8","81":"11be8e76"}[chunkId] + ".chunk.js";
};